import { apiSlice } from "../../../app/services/apiSlice";

const VIDEO_PROFILE_URL = 'video-profiles/';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    getAllVideoProfiles: builder.query({
      query: (params) => ({
        url: `video-profiles`,
        params,
      }),
    }),
    getAllVideoProfile: builder.mutation({
      query: (params) => ({
        url: `video-profiles`,
        params
      }),
    }),
    getVideoProfiles: builder.mutation({
      query: (params) => ({
        method: 'GET',
        url: `video-profiles`,
        params,
      }),
      transformResponse: (responseData) => {
        responseData['options'] = responseData?.videoProfiles?.map(
          (videoprofile) => ({
            shortCode: videoprofile?.shortCode,
            name: videoprofile?.name,
            title: videoprofile?.title,
            id: videoprofile?.id,
          }),
        );
        return responseData || {};
      },
    }),
    deleteVideoProfiles: builder.mutation({
      query: (params) => ({
        url: `${VIDEO_PROFILE_URL}${params}`,
        method: 'DELETE',
      }),
    }),
    addNewVideoProfile: builder.mutation({
      query: (data) => ({
        url: `${VIDEO_PROFILE_URL}`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    updateVideoProfile: builder.mutation({
      query: (data) => ({
        url: `${VIDEO_PROFILE_URL}${data.id ?? data.videoProfileId}`,
        method: 'PUT',
        body: {
          ...data,
        },
      }),
    }),
    getVideoProfileById: builder.query({
      query: (id) => ({
        url: `${VIDEO_PROFILE_URL}${id}`,
        method: 'GET',
      }),
    }),
    // getApplicationAllVideoProfile: builder.query({
    //   query: (params) => ({
    //     url: `/applications/${params?.id}/${VIDEO_PROFILE_URL}`,
    //     method: 'GET',
    //   }),
    // }),

    getClientVideoProfileDetails: builder.query({
      query: ({ noCache, ...params }) => {
        const headers = {};

        if (noCache) {
          headers["Cache-Control"] = "no-store";
          headers["Pragma"] = "no-cache";
          headers["Expires"] = "0";
        }

        return {
          url: `public/${VIDEO_PROFILE_URL}vp-details/questionnaire`,
          method: "GET",
          params,
          headers,
          cache: noCache ? "no-store" : "default",
        };
      },
    }),


    getAddReferencesData: builder.query({
      query: ({ noCache, ...params }) => {
        const headers = {};

        if (noCache) {
          headers["Cache-Control"] = "no-store";
          headers["Pragma"] = "no-cache";
          headers["Expires"] = "0";
        }

        return {
          url: `public/forms/application-form`,
          method: "GET",
          params,
          headers,
          cache: noCache ? "no-store" : "default",
        };
      },
    }),

    submitCandidateForm: builder.mutation({
      query: (formData) => ({
        url: `public/forms/application-form?token=${formData.get('token')}`, // token in URL
        method: 'POST',
        body: formData, // send FormData directly
      }),
    }),

    resendVideoProfile: builder.mutation({
      query: (data) => ({
        url: `${VIDEO_PROFILE_URL}vp-resend/${data?.id}`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),

    resetVideoProfile: builder.mutation({
      query: (data) => ({
        url: `${VIDEO_PROFILE_URL}vp-reset/${data?.id}`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),

    getCompanyInfo: builder.query({
      query: (params) => ({
        url: `public/company/details`,
        method: 'GET',
        params
      }),
    }),
    getVideoProfileByParamId: builder.mutation({
      query: (id) => ({
        url: `${VIDEO_PROFILE_URL}${id}`,
        method: 'GET',
      }),
    }),

    preSignedVpUrl: builder.mutation({
      query: ({ token, ...data }) => ({
        url: `public/candidates/presigned-video-profile-doc?token=${token}`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),

    getApplicationVP: builder.query({
      query: ({ id }) => ({
        url: `${VIDEO_PROFILE_URL}application/${id}`,
        method: 'GET',

      }),
    }),

    uploadVPAnswer: builder.mutation({
      query: ({ token, ...data }) => ({
        url: `public/${VIDEO_PROFILE_URL}save-answer?token=${token}`,
        method: 'POST',
        body: { ...data },
      }),
    }),

    SubmitVideoProfile: builder.mutation({
      query: ({ token, ...data }) => ({
        url: `public/${VIDEO_PROFILE_URL}vp-form/submit?token=${token}`,
        method: 'PUT',
        body: {
          ...data,
        },
      }),
    }),

    startSession: builder.mutation({
      query: ({ token, ...data }) => ({
        url: `public/${VIDEO_PROFILE_URL}vp-form/start-session?token=${token}`,
        method: 'PUT',
        body: {
          ...data,
        },
      }),
    }),

  }),

});

export const {
  useDeleteVideoProfilesMutation,
  useSubmitVideoProfileMutation,
  useGetApplicationVPQuery,
  useResendVideoProfileMutation,
  useResetVideoProfileMutation,
  useUploadVPAnswerMutation,
  usePreSignedVpUrlMutation,
  useGetClientVideoProfileDetailsQuery,
  useGetCompanyInfoQuery,
  useStartSessionMutation,
  useGetAddReferencesDataQuery,
  useSubmitCandidateFormMutation,
  useGetAllVideoProfileMutation,
  useGetAllVideoProfilesQuery,
  useGetVideoProfilesMutation,
  useAddNewVideoProfileMutation,
  useUpdateVideoProfileMutation,
  useGetVideoProfileByIdQuery,
  useGetVideoProfileByParamIdMutation,
  // useGetApplicationAllVideoProfileQuery
} = extendedApiSlice;
